<template>
  <div class="container">
    <div class="row h-50">
      <div
        v-if="loading"
        class="row d-flex justify-content-center align-middle my-4"
      >
        <h3>Loading magical things :)</h3>
      </div>
      <div class="col-8 offset-2 my-4" v-else>
        <h2 class="message">Enter your BLE Serial Numbers to Register</h2>
        <p>Note: *PROD BE CAREFUL*!! Most data is autogenerated</p>
        <p>
          <label class="message" for="bleserone">BLE Serial Row 1</label>
          <input
            class="form-control my-2"
            id="bleserone"
            v-model="bleserone"
            type="text"
            name="bleserone"
          />
          <label class="message" for="blesertwo">BLE Serial Row 2</label>
          <input
            class="form-control my-2"
            id="blesertwo"
            v-model="blesertwo"
            type="text"
            name="blesertwo"
          />
          <label class="message" for="bleserone">BLE Serial Row 3</label>
          <input
            class="form-control my-2"
            id="bleserthree"
            v-model="bleserthree"
            type="text"
            name="bleserthree"
          />
          <label class="message" for="bleserfour">BLE Serial Row 4</label>
          <input
            class="form-control my-2"
            id="bleserfour"
            v-model="bleserfour"
            type="text"
            name="bleserfour"
          />
          <label class="message" for="bleserfive">BLE Serial Row 5</label>
          <input
            class="form-control my-2"
            id="bleserfive"
            v-model="bleserfive"
            type="text"
            name="bleserfive"
          />
          <label class="message" for="vehicleID">Vehicle ID</label>
          <input
            class="form-control my-2"
            id="vehicleID"
            v-model="vehicleID"
            type="text"
            name="vehicleID"
          />
          <label class="message" for="encryptedVehicleKey">Vehicle MVK</label>
          <input
            class="form-control my-2"
            id="encryptedVehicleKey"
            disabled
            v-model="encryptedVehicleKey"
            type="text"
            name="encryptedVehicleKey"
          />
          <label class="message" for="transportKey">Transport Key</label>
          <input
            class="form-control my-2"
            id="transportKey"
            v-model="transportKey"
            type="text"
            name="transportKey"
          />
        </p>

        <div v-if="transportKeyList">
          <p>Transport Keys</p>
          <div v-for="transportKeyItem in transportKeyList">
            <p>{{ transportKeyItem.label }}</p>
          </div>
        </div>

        <h4>Distributor General Access Token</h4>
        <textarea>{{ generalAccessToken }}</textarea>
        <div class="py-3" style="text-align: center">
          <button class="ty-button" v-on:click="generateVehicleID">
            1. Generate Vehicle ID
          </button>
          <button class="ty-button" v-on:click="generateRandomINT_MVK">
            2. Generate MVK
          </button>
          <button class="ty-button" v-on:click="obtainTransportKeyLabel">
            3. Generate Transport Keys
          </button>
          <button class="ty-button" v-on:click="generateDistributorAccessToken">
            4. Generate DAT
          </button>
          <button class="ty-button" v-on:click="requestRegisterVehicle">
            5. Add Vehicle
          </button>
        </div>
        <div v-if="vehicleData != null">
          <p>{{ vehicleData }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BigNumber from "bignumber.js";
import { analytics } from "../../config/firebaseInit";

export default {
  name: "dkaddvehicle",
  data: function () {
    return {
      bleserone: "",
      blesertwo: "",
      bleserthree: "",
      bleserfour: "",
      bleserfive: "",
      vehicleID: "",
      encryptedVehicleKey: "",
      transportKey: "",
      loading: false,
      vehicleData: null,
      transportKeyList: null,
      generalAccessToken: null,
    };
  },
  created() {
    analytics.logEvent("dk-add-vehicle");
  },
  methods: {
    generateDistributorAccessToken: async function () {
      // TODO - Environment variables for url
      const config = {
        method: "post",
        url: "https://cqhvpj3513.execute-api.us-west-2.amazonaws.com/staging/dat",
      };

      this.axios(config)
        .then((response) => {
          console.log(response);
          console.log(JSON.stringify(response.data));
          this.generalAccessToken = response.data.access_token;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    obtainTransportKeyLabel: async function () {
      // TODO - Environment variables for url
      const config = {
        method: "get",
        url: "https://72iix315pa.execute-api.us-west-2.amazonaws.com/staging/registervehicle",
      };

      this.axios(config)
        .then((response) => {
          if (response.data) {
            const rows = response.data.results.rows;
            console.log(rows);
            const row = rows[0];
            console.log(row);
            this.transportKeyList = rows;
            this.transportKey = row.label;
            return row.label;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    generateVehicleID: async function () {
      console.log("Generating Vehicle ID.");
      const lineOne = this.bleserone;
      const lineTwo = this.blesertwo;
      const lineThree = this.bleserthree;
      const lineFour = this.bleserfour;
      const lineFive = this.bleserfive;
      let masterBinaryString = "";
      console.dir(this.hex2bin(lineOne));
      const lineOneBinaryString = this.hex2bin(lineOne);
      const lineOneBinaryLessThreeBits =
        this.removeThreeBits(lineOneBinaryString);
      console.log("lineOneBLess: ", lineOneBinaryLessThreeBits);
      const lineTwoBinaryString = this.hex2bin(lineTwo);
      const lineTwoBinaryLessThreeBits =
        this.removeThreeBits(lineTwoBinaryString);
      console.log("lineTwoBLess: ", lineTwoBinaryLessThreeBits);
      const lineThreeBinaryString = this.hex2bin(lineThree);
      const lineThreeBinaryLessThreeBits = this.removeThreeBits(
        lineThreeBinaryString
      );
      console.log("lineThreeBLess: ", lineThreeBinaryLessThreeBits);
      const lineFourBinaryString = this.hex2bin(lineFour);
      const lineFourBinaryLessThreeBits =
        this.removeThreeBits(lineFourBinaryString);
      console.log("lineFourBLess: ", lineFourBinaryLessThreeBits);
      const lineFiveBinaryString = this.hex2bin(lineFive);
      const lineFiveBinaryLessThreeBits =
        this.removeThreeBits(lineFiveBinaryString);
      console.log("lineFiveBLess: ", lineFiveBinaryLessThreeBits);

      masterBinaryString += lineOneBinaryLessThreeBits;
      masterBinaryString += lineTwoBinaryLessThreeBits;
      masterBinaryString += lineThreeBinaryLessThreeBits;
      masterBinaryString += lineFourBinaryLessThreeBits;

      console.log("master bin: ", masterBinaryString);
      console.log("master bin string count: ", masterBinaryString.length);
      console.log("master bits 64 - 128: ", masterBinaryString.slice(64, 128));
      console.log("discard this: ", masterBinaryString.slice(0, 64));

      const binaryEcuId = masterBinaryString.slice(64, 128);
      console.log("master bin string count: ", binaryEcuId.length);

      const hexEcuId = BigNumber(binaryEcuId, 2).toString(16).toUpperCase();

      const paddedEcuId = hexEcuId.padStart(16, "0");
      console.log("final value: ", paddedEcuId);
      this.vehicleID = paddedEcuId;
    },
    hex2bin: function (hex) {
      return BigNumber(hex, 16)
        .toString(2)
        .padStart(4 * hex.length, "0");
    },
    removeThreeBits: function (binaryString) {
      const substring = binaryString.slice(3);
      console.log(substring);
      return substring;
    },
    requestRegisterVehicle: async function () {
      if ("" === this.vehicleID) {
        alert("Please input vehicleId");
        return;
      }
      if ("" === this.encryptedVehicleKey) {
        alert("Please input intMVK");
        return;
      }
      // this.vehicleMVK = this.generateRamdomINT_MVK()

      // console.log("VMVK: ", this.vehicleMVK)
      const data = JSON.stringify({
        vehicleId: this.vehicleID,
        subjectId: this.vehicleID,
        encryptedVehicleKey: this.encryptedVehicleKey,
        transportKey: this.transportKey,
      });

      const url =
        "https://72iix315pa.execute-api.us-west-2.amazonaws.com/staging/registervehicle";

      const config = {
        method: "post",
        url: url,
        headers: {
          "Content-Type": "application/json",
          Authentication: `Bearer ${this.generalAccessToken}`,
        },
        data: data,
      };
      this.axios(config)
        .then((response) => {
          this.loading = false;
          console.log(response);
          this.vehicleData = response.data;
          alert(`Vehicle Created!`);
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
          alert(`Well that was unexpected.  ${error}`);
        });
    },
    generateRandomINT_MVK: function () {
      const len = 32;
      const c = "ABCDEF0123456789";
      const clen = c.length;
      let ret = "";

      for (let i = 0; i < len; i++) {
        ret += c[Math.floor(Math.random() * clen)];
      }
      this.encryptedVehicleKey = ret;
      return ret;
    },
  },
};
</script>

<style>
.ty-button {
  background: #d92429;
  border-radius: 28px;
  width: 320px;
  height: 56px;
  font-family: ToyotaType-Semibold;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0.73px;
  text-align: center;
}
</style>
